"use client"

import Link from "next/link"
import { useFavoriteSounds } from "@/hooks/useFavoriteSounds"

/**
 * The header's "Saved" link. A client island so the header itself can stay a
 * server component outside the Suspense boundary; the count appears once the
 * saved list has been read from storage.
 */
export default function SavedLink({ className }: { className: string }) {
  const { favoriteCount, hasHydrated } = useFavoriteSounds()

  return (
    <Link prefetch={false} href="/sounds/saved" className={className}>
      Saved{hasHydrated ? ` ${favoriteCount}` : ""}
    </Link>
  )
}
